/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_016: Question = {
  id: 'pres-016-zones-noyaux-pdza',
  oldId: '30',
  title: 'Intégration des zones noyaux ou des milieux naturels d’intérêt et du concept de corridor de connectivité dans le Plan de développement de la zone agricole (PDZA)',
  number: '2.16',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 3,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      score: '0',
      scoringFct: (data: string[]) => parseFloat(data[0]),
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_pres_016__v3: Question = {
  ...question_pres_016,
  number: '2.14',
};

export const question_pres_016_v2: Question = question_pres_016;
export const question_pres_016_v3: Question = question_pres_016__v3;
